// ================
// 1. Features
// ================

var featuresMenu = document.querySelector('.features__menu');
var featuresMenuItem = document.querySelectorAll('.features__menu .menu-features-item');
var featuresItems = document.querySelectorAll('.features__item');
var featuresMenuMarker = document.querySelector('.menu-features__marker');
var featuresSelect = document.querySelector(".features__select select");

if (featuresMenu) {

    function updateMarkerPosition(activeItem) {
        featuresMenuMarker.style.top = activeItem.offsetTop + activeItem.clientHeight / 2 + 'px';
    }

    featuresMenuItem.forEach(function (item) {
        item.onclick = function (e) {
            if (this.classList.contains('is-active')) return;

            var activeItem = this.dataset.count;

            featuresMenuItem.forEach(function (item) {
                return item.classList.remove('is-active');
            });
            featuresItems.forEach(function (item) {
                return item.classList.remove('is-active');
            });

            this.classList.add('is-active');
            document.querySelector(`.features__item[data-name="${activeItem}"]`).classList.add('is-active');

            updateMarkerPosition(this);
        };
    });

    if (featuresSelect) {
        featuresSelect.addEventListener('change', function (e) {
            featuresItems.forEach(function (item) {
                return item.classList.remove('is-active');
            });
            if (e.target.selectedOptions && e.target.selectedOptions[0]) {
                featuresItems[e.target.selectedOptions[0].id - 1].classList.add('is-active');
            }
        });
    }
}
